/* eslint-disable indent, react/prop-types, react/jsx-indent, react/jsx-indent-props */
import React, { useEffect, useState, useRef } from "react";
import { useParams, useHistory } from "react-router";
import {
  Container,
  Row,
  Col,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
  Alert,
} from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import API from "../Utility";
import Spinner from "react-bootstrap/Spinner";
import Table from "../Utility/Table";
import BootstrapTable from "react-bootstrap-table-next";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { LinkContainer } from "react-router-bootstrap";
import EditableTextInput from "../EditableTextInput";
import { ThemedView } from "../Theme";
import ConfirmationModal from "../ConfirmationModal";
import Moment from "react-moment";

// Styles
import "./CampaignView.scss";

export default function CampaignView({
  children,
  location,
  ...routeProps
}) {
  let { project, campaignId } = useParams();

  let history = useHistory();

  const [campaignData, setCampaignData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteMessageShow, setDeleteMessageShow] = useState(false);
  const [deleteMessageError, setDeleteMessageError] = useState();
  const [duplicateModalShow, setDuplicateModalShow] = useState(false);
  const [duplicateMessageShow, setDuplicateMessageShow] = useState(false);
  const [showAllGroups, setShowAllGroups] = useState(false);

  async function getCampaignData(query) {
    setCampaignData([]);
    if (!isLoading) {
      setIsLoading(true);
    }
    const data = await API.get({
      url: query.url,
      params: query.params,
    });
    setIsLoading(false);
    setCampaignData(data);
    if (data.groups && data.groups.length <= 10) {
      setShowAllGroups(true);
    }
  }

  useEffect(() => {
    async function initializeData() {
      await getCampaignData({
        url: `/admin/${project}/campaigns/${campaignId}`
      });
    }
    initializeData();
  }, []);

  if (isLoading) {
    return (<div>
      <Spinner animation="border" />
    </div>);
  }

  const columns = [
    {
      text: "No.",
      dataField: 'groupId',
      formatter: function callback(cell, row, rowIndex) {
        return (
          <div>
            <span>
              {rowIndex + 1}.
            </span>
          </div>
        );
      },
      style: { width: '80px', borderRight: 'none' },
      headerStyle: { width: '80px', borderRight: 'none' }
    },
    {
      text: "Name",
      dataField: 'groupName',
      formatter: function callback(cell, row, rowIndex) {
        return (
          <div>
            <span>{row.groupName}</span>
          </div>
        );
      },
      style: { borderLeft: 'none', borderRight: 'none' },
      headerStyle: { borderLeft: 'none', borderRight: 'none' }
    },
    {
      dataField: "score",
      text: "Progress",
      formatter: function callback(cell) {
        return (
          <span>
            {cell}%
          </span>
        );
      },
      style: { borderLeft: 'none' },
      headerStyle: { borderLeft: 'none' }
    }
  ];

  const confirmDelete = async(event, exitValue) => {
    if (exitValue === true) {
      setDeleteMessageShow(true);
      setDeleteMessageError(null);
      await deleteResponse({
        url: `/admin/${project}/campaigns/${campaignId}/delete`
      });
    } else {
      setDeleteModalShow(false);
    }
  };
  async function deleteResponse(query) {
    try {
      await API.delete({
        url: query.url,
        data: query.data,
      });
      setDeleteModalShow(false);
      history.push({
        pathname: `/campaigns/${project}`,
      });
    } catch (err) {
      setDeleteMessageError({
        message: err?.response?.data?.message || "An error occurred while deleting this campaign."
      });
    }
  }

  const confirmDuplicate = async(event, exitValue) => {
    if (exitValue === true) {
      setDuplicateMessageShow(true);
      await duplicateResponse({
        url: `/admin/${project}/campaigns/${campaignId}/duplicate`,
      });
    } else {
      setDuplicateModalShow(false);
    }
  };
  async function duplicateResponse(query) {
    const data = await API.get({
      url: query.url,
      data: query.data,
    });
    setDuplicateModalShow(false);
    history.push({
      pathname: `/campaigns/${project}/${data._id}/update`,
    });
  }

  return (
    < div className="campaign-view">
      <Row>
        <Col>
          <Breadcrumb as="nav" bsPrefix="breadcrumb ph-admin__breadcrumb">
            <LinkContainer to={`/campaigns/${project}`}>
              <Breadcrumb.Item bsPrefix="breadcrumb-item clickable">
                Campaigns
              </Breadcrumb.Item>
            </LinkContainer>
            <Breadcrumb.Item active>{campaignData.name}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col lg={6}>
          <h2>{campaignData.name}</h2>
        </Col>
        <Col lg={6}>
          <div className="campaign-view__actions flex flex-row">
            <Button
              onClick={() => {
                setDuplicateModalShow(true);
              }}
              variant="outline-primary"
            ><span style={{ verticalAlign: "middle" }}>Duplicate</span>
            </Button>
            {
              campaignData.status !== 'published' ? (
                <Button
                  onClick={() => {
                    setDeleteModalShow(true);
                  }}
                  variant="outline-primary"
                ><span style={{ verticalAlign: "middle" }}>Delete</span>
                </Button>
              ) : <></>
            }

            <Button
              onClick={() => {
                history.push({
                  pathname: `/campaigns/${project}/${campaignData._id}/update`,
                });
              }}
              variant="primary"
            ><span style={{ verticalAlign: "middle" }}>Edit</span>
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className='campaign-view-label'>Status</Col>
      </Row>
      <Row>
        <Col>{campaignData.status?.[0]?.toUpperCase()}{campaignData.status?.substring(1)}</Col>
      </Row>
      <p></p>
      <Row>
        <Col className='campaign-view-label'>Description</Col>
      </Row>
      <Row>
        <Col>{campaignData.description}</Col>
      </Row>
      <p></p>
      <Row>
        <Col className='campaign-view-label'>Start Date</Col>
        <Col className='campaign-view-label'>End Date</Col>
        <Col></Col>
        <Col></Col>
      </Row>
      <Row>
        <Col>
          <Moment format="DD MMM 'YY">{campaignData.startDate}</Moment>
        </Col>
        <Col>
          <Moment format="DD MMM 'YY">{campaignData.endDate}</Moment>
        </Col>
        <Col></Col>
        <Col></Col>
      </Row>
      <p></p>
      <Row>
        <Col className='campaign-view-label'>Scoring</Col>
      </Row>
      <Row>
        <Col className='campaign-view-sublabel'>Campaign Goal:</Col>
        <Col className='campaign-view-sublabel'>Compete Against:</Col>
        <Col className='campaign-view-sublabel'>Calculate Using:</Col>
        {/* <Col className='campaign-view-sublabel'>Time Limits:</Col> */}
      </Row>
      <Row>
        <Col className="">Most courses completed</Col>
        <Col className="">Groups against each other</Col>
        <Col className="">Course completion</Col>
        {/* <Col className="">Limit to campaign time window</Col> */}
      </Row>
      <p></p>
      <Row>
        <Col className='campaign-view-label'>Courses</Col>
      </Row>
      <Row>
        <Col>
          {campaignData && campaignData.courses && campaignData.courses.map(function(course, i) {
            return <Button className="btn btn-secondary btn-disabled" key={i}>{course.name}</Button>;
          })}
        </Col>
      </Row>
      <p></p>
      <Row>
        <Col className='campaign-view-label'>Groups</Col>
      </Row>
      <Row>
        <Col>
          {campaignData && campaignData.groups && campaignData.groups.map(function(group, i) {
            if (showAllGroups || !showAllGroups && i < 10) {
              return <Button className="btn btn-secondary btn-disabled" key={i}>{group.name}</Button>;
            } else if (showAllGroups || !showAllGroups && i === 10) {
              return <>
                <Button className="btn btn-secondary show-all-btn" key={i} onClick={() => {
                  setShowAllGroups(true);
                }}>Show All</Button>
              </>;
            } else {
              return <></>;
            }
          })}
        </Col>
      </Row>

      <p></p>
      <hr />
      <p></p>
      <Row>
        <Col><h2>Leaderboard</h2></Col>
      </Row>
      {campaignData && campaignData.status === 'draft' &&
        <Row>
          <Col><p>The leaderboard will be generated when the campaign is published</p></Col>
        </Row>
      }
      {!campaignData.leaderboard && campaignData.status !== 'draft' && campaignData.generatingInitialLeaderboard &&
        <Row>
          <Col><p>The leaderboard is being generated for the first time</p></Col>
        </Row>
      }
      {campaignData.leaderboard && campaignData.status !== 'draft' && !campaignData.generatingInitialLeaderboard &&
        <Row>
          <Col>
            <BootstrapTable
              bootstrap4
              striped
              hover
              columns={columns}
              keyField={"_id"}
              data={campaignData?.leaderboard?.scores}
              noDataIndication={<div>No data</div>}
              rowClasses={"react-bootstrap-table__row"}
            // headerClasses={"hide"}
            />
          </Col>
        </Row>
      }
      <ConfirmationModal
        title={
          "Delete Campaign"
        }
        body={
          <>
            <p className={deleteMessageShow ? "hide" : ""}>
              Are you sure you want to delete this campaign?
            </p>
            <p className={deleteMessageShow ? "" : "hide"}>
              {deleteMessageError ? deleteMessageError?.message : 'Deleting campaign...'}
            </p>
          </>
        }
        show={deleteModalShow}
        confirmtext={"Delete"}
        onHide={(event, exitValue) => {
          if (!deleteMessageShow || deleteMessageError) {
            confirmDelete(event, exitValue);
          }
        }}
        showspinner={deleteMessageShow && !deleteMessageError}
      />
      <ConfirmationModal
        title={
          "Duplicate Campaign"
        }
        body={
          <>
            <p className={duplicateMessageShow ? "hide" : ""}>
              Are you sure you want to duplicate this campaign?
            </p>
            <p className={duplicateMessageShow ? "" : "hide"}>
              Duplicating campaign...
            </p>
          </>
        }
        show={duplicateModalShow}
        confirmtext={"Duplicate"}
        onHide={(event, exitValue) => {
          if (!duplicateMessageShow) {
            confirmDuplicate(event, exitValue);
          }
        }}
        showspinner={duplicateMessageShow}
      />
    </div >
  );
}
